export default () => `
  {
    currentStore {
      currency {
        code
        symbol
        thousandsSeparator
        decimalMark
        symbolFirst
      }
      customerServiceEmail
      customerServicePhone
      returnsInformation
      shipping {
        cost
        threshold
      }
      shippingInformation
    }
  }
`
